import { ReactElement } from 'react';
import InfoLabel from '../../../Components/InfoLabel';

export function LabelValueNameInfoLabel(): ReactElement {
  return (
    <InfoLabel
      label="Name"
      description="Shown to users in the CMS, on the website, and in other user-facing places."
    />
  );
}

export function LabelValueValueInfoLabel(): ReactElement {
  return (
    <InfoLabel
      label="Value"
      description="Saved in the database and used by search/filters. Change carefully, because existing products may already use it."
    />
  );
}
